import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../mocks';
import { noteFactory } from '@trukt/utils/noteFactory';

const notes = noteFactory.buildList(3);

export const handlers = [
  http.get(mockTruktTmsApiUrl('/order/:orderGuid/notes'), () =>
    HttpResponse.json({
      pg: 1,
      rc: 3,
      results: notes,
      total: notes.length,
    }),
  ),
];
